import styled, { css, keyframes } from 'styled-components'

export const HeaderMain = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  position: relative;
  align-items: center;
  background-color: transparent;

  .utils {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-radius: 42px 42px 42px 42px;
    height: 50pxx;
    align-items: center;
    padding: 0 20px;
  }

  .hamburgue {
    display: none;
  }

  .selects {
    display: flex;
    height: 100%;

    a {
      text-decoration: none;
      color: rgb(255, 255, 255);
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      border-radius: 15px;
    }
  }

  @media (max-width: 1000px) {
    .utils {
      display: none;
    }
    .hamburgue {
      display: flex;
      width: 100%;
      top: 0;
      left: 0;

      button {
        position: absolute;
        top: 40px;
        z-index: 10000000;
        left: 20px;
        background-color: transparent;
        border: none;
        cursor: pointer;
      }
    }

    .mobile {
      display: flex;
      position: absolute;
      flex-direction: column;
      background: ${(props) => props.theme.surface};
      height: 100dvh;
      z-index: 1000000;
      width: 100%;
      left: 0;
      padding: 90px 20px;
      top: 0;
      align-items: center;
      animation: openMenu 400ms;

      .selects {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 20px;
        height: 100%;

        button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2a365e;
          font-size: 18px;
          gap: 20px;
        }
      }

      .filter {
        position: absolute;
        top: 40px;
        right: 30px;
      }
    }

    @keyframes openMenu {
      from {
        height: 0;
        overflow: hidden;
      }
      to {
        height: 100dvh;
      }
    }
  }

  .filter {
    background: ${(props) => (props.theme.name === 'light' ? '#001f5c' : 'rgba(0, 31, 92, 0.85)')};
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    width: 44px;
    height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;

    &:hover {
      background: #a6c10b;
      transform: translateY(-1px);
      svg {
        color: #001842 !important;
      }
    }

    svg {
      color: #ffffff;
      transition: all 0.2s ease;
    }

    img {
      width: 25px;
    }
  }
`

export const HeaderLogo = styled.div`
  display: flex;
  padding: 20px;

  img {
    width: 100px;
  }

  @media (max-width: 1000px) {
    display: flex;
    justify-content: end;
    width: 100%;
  }

  > button.logout {
    border: solid 2px #a6c10b;
    background-color: ${(props) => (props.theme.name === 'light' ? '#001f5c' : props.theme.surface)};
    border-radius: 500px;
    color: #ffffff;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    font-size: 12px;
    font-weight: 700;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
      border-color: #ffffff;
    }
  }
`

export const FilterModal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 1000000;
  align-items: end;
  right: 125px;
  height: 300px;
  width: 500px;
  top: 75px;
  position: absolute;
  border-radius: 10px;

  .header {
    background: #002b80;
    border-radius: 10px 10px 0 0;
    height: 40px;
    width: 100%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    font-size: 12px;
  }
  .body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: rgba(243, 245, 248, 1);
    padding: 20px;
    width: 100%;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.3);

    select {
      height: 40px;
      border: none;
      border-radius: 27px;
      width: 100%;
      padding: 0 10px;
      box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      padding: 0 20px;

      &:focus {
        outline: none;
      }
    }

    .button {
      display: flex;
      width: 100%;
      justify-content: end;
      gap: 10px;
    }

    .cancel {
      background-color: #990000;
    }

    .ok {
      transition: all ease-in-out 400ms;

      background-color: #274e13;
      &:disabled {
        background-color: #7e7e7e93;
        transition: all ease-in-out 1s;
      }
    }

    .buttons {
      background-color: #00205b;
    }

    .react-calendar {
      width: 350px;
      position: absolute;
      right: 0;
      top: 100px;
      padding: 10px 20px;
      max-width: 100%;
      background: white;
      z-index: 200000000000000000;
      border: none;
      border-radius: 10px;
      font-family: 'Montserrat', Arial, Helvetica, sans-serif;
      line-height: 1.125em;
    }
    .react-calendar--doubleView {
      width: 700px;
    }
    .react-calendar--doubleView .react-calendar__viewContainer {
      display: flex;
      margin: -0.5em;
    }
    .react-calendar--doubleView .react-calendar__viewContainer > * {
      width: 50%;
      margin: 0.5em;
    }
    .react-calendar,
    .react-calendar *,
    .react-calendar *:before,
    .react-calendar *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .react-calendar button {
      margin: 0;
      border: 0;
      outline: none;
    }
    .react-calendar button:enabled:hover {
      cursor: pointer;
    }
    .react-calendar__navigation {
      height: 44px;
      margin-bottom: 1em;
    }
    .react-calendar__navigation button {
      min-width: 44px;
      background: none;
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: #e6e6e6;
    }
    .react-calendar__navigation button[disabled] {
      background-color: #f0f0f0;
    }
    .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: capitalize;
      font-weight: bold;
      font-size: 0.75em;
    }

    .react-calendar__month-view__weekdays__weekday {
      padding: 0.2em;
    }
    .react-calendar__month-view__weekNumbers {
      font-weight: bold;
    }
    .react-calendar__month-view__weekNumbers .react-calendar__tile {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75em;
      padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
    }
    .react-calendar__month-view__days__day--weekend {
      color: #d10000;
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: #757575;
    }
    .react-calendar__year-view .react-calendar__tile,
    .react-calendar__decade-view .react-calendar__tile,
    .react-calendar__century-view .react-calendar__tile {
      padding: 2em 0.5em;
    }
    .react-calendar__tile {
      max-width: 100%;
      text-align: center;
      padding: 0;
      background: none;
      width: 10px;
      height: 50px;
    }
    .react-calendar__tile:disabled {
      background-color: #f0f0f0;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
      background-color: #002b80;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now {
      background: #100797ff;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now:enabled:hover,
    .react-calendar__tile--now:enabled:focus {
      background: #1509b8ff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive {
      background: #76baff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive:enabled:hover,
    .react-calendar__tile--hasActive:enabled:focus {
      background: #a9d4ff;
      border-radius: 500px;
    }
    .react-calendar__tile--active {
      background: #006edc;
      color: white;
      border-radius: 500px;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
      background: #1087ff;
      border-radius: 500px;
    }
    .react-calendar--selectRange .react-calendar__tile--hover {
      background-color: #e6e6e6;
      border-radius: 500px;
    }
  }

  &:before {
    position: absolute;
    content: ' ';
    width: 15px;
    height: 15px;
    right: 17px;
    top: -5px;
    border-radius: 4px;
    background: ${(props) => props.theme.surface};
    rotate: 225deg;
  }

  button,
  label {
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 27px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
  }

  @keyframes showModal {
    from {
      height: 0;
      overflow: hidden;
    }
  }
`

export const LogoutModal = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 99999999999;
  right: 30px;
  top: 80px;
  justify-content: space-between;
  position: absolute;
  background: ${(props) => (props.theme.name === 'light' ? '#001f5c' : props.theme.surface)};
  gap: 10px;
  border-radius: 12px;
  animation: showModal 400ms;
  width: 250px;
  border: solid 2px #a6c10b;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);

  a {
    font-size: 14px;
    text-decoration: none;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    font-weight: 600;
    gap: 8px;
    align-items: center;
    padding: 12px 20px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #a6c10b;
      transition: all ease-in-out 200ms;
    }
  }

  &:before {
    position: absolute;
    content: ' ';
    width: 15px;
    height: 15px;
    right: 8px;
    top: -10px;
    background-color: ${(props) => (props.theme.name === 'light' ? '#001f5c' : props.theme.surface)};
    rotate: 225deg;
    border-bottom: solid 2px #a6c10b;
    border-right: solid 2px #a6c10b;
  }

  button {
    border: none;
    display: flex;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
    color: #ffffff;
    padding: 0 20px;
    height: 42px;
    gap: 8px;
    justify-content: end;
    background-color: rgba(0, 0, 0, 0.25);
    font-weight: 600;
    border-radius: 0 0 10px 10px;
    font-family: 'Montserrat', sans-serif;

    &:hover {
      background-color: rgba(239, 68, 68, 0.3);
      color: #fca5a5;
      transition: all ease-in-out 200ms;
    }
  }

  @keyframes showModal {
    from {
      height: 0;
      overflow: hidden;
    }
    to {
      height: 150px;
    }
  }
`

const FadeInButton = keyframes`
from {
opacity: 0;

}
to {
opacity: 1;

}
`

interface NavButtonProps {
  $active: boolean
}

export const NavButton = styled.button<NavButtonProps>`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: start;
  gap: 0;
  margin: 0 5px;
  overflow: hidden;
  height: 50px;
  font-size: 24px;
  border-radius: 8px;
  color: rgb(255, 255, 255);
  transition: all ease-in-out 300ms;
  padding: 0 10px;

  img {
    width: 24px;
    height: 24px;
  }

  p {
    margin: 0;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    white-space: nowrap;
    opacity: 0;
    max-width: 0;
    overflow: hidden;
    transition: all ease-in-out 300ms;
  }

  ${({ $active }) =>
    $active &&
    css`
      color: #a6c10b;
      gap: 10px;
      padding: 0 15px;

      p {
        opacity: 1;
        max-width: 200px;
      }
    `}
`

export const ButtonLabel = styled.span`
  font-size: 12px;
  color: #2a365e;
  animation: 1s show;

  @keyframes show {
    from {
      opacity: 0;
      width: 0;
      overflow: hidden;
    }

    to {
      opacity: 1;
      width: 100px;
    }
  }
`

export const ArquivosButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: start;
  gap: 10px;
  margin: 0 10px;
  overflow: hidden;
  height: 50px;
  font-size: 24px;
  width: 50px;
  border-radius: 8px;
  color: rgb(255, 255, 255);
  transition: all ease-in 400ms;

  img {
    width: 24px;
    height: 24px;
  }
`
export const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 999999999999,
}

export const modalContentStyle: React.CSSProperties = {
  backgroundColor: 'rgb(0, 24, 66)',
  padding: '24px',
  borderRadius: '8px',
  width: '90%',
  fontFamily: "'Montserrat', sans-serif",
  color: '#ffffff',
  maxWidth: '400px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
}
